import axios from 'axios'
import {
	Toast
} from 'vant';
import router from '../router/index'
import * as  requestUrl from '../../public/index.js'

// let baseUrl = 'http://zjgzh.mjxxkj.cn';
import {
	getTokens
} from './api';
// console.log(requestUrl.requestUrl)
const service = axios.create({
	baseURL: requestUrl.requestUrl+ '/mjapi',
	// withCredentials: true, // send cookies when cross-domain requests
	timeout: 100000 // request timeout
})

// request interceptor
service.interceptors.request.use(
	config => {
		return config

	},
	error => {

		// do something with request error
		console.log(error) // for debug
		return Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(

	response => {
		const res = response.data
		console.log(res)
		// if the custom code is not 20000, it is judged as an error.
		// debugger;
		if (res.success) {
			if(res.result&&res.result.token){
				localStorage.setItem("token",res.result.token)
			}
		}
			
			//  500  重新登录
			if (res.code == 500 ) {
				Toast(res.message)
				return
			}
			
			if(res.code==9008){
				//token无效,请清理缓存	
				Toast(res.message)
				console.info("code=9008,token无效,请清理缓存")
				localStorage.removeItem("token")				
				 window.locaiton.reload()
			}else if(res.code==9007){
				Toast(res.message)
				console.info("code=9007,无token,请重新登陆")
				router.go(0)
			}else if(res.code==9005){
				Toast(res.message)
				localStorage.clear()
				console.info("code=9005,用户没有注册，跳转到注册页面")
				router.push("/regester")
				
			}else if(res.code==9002){
				Toast(res.message)
				console.info("code=9002,code无效，重新申请")
				localStorage.clear()
			}else if(res.code==9009 || res.code==510 || res.code==9011){
				localStorage.setItem('message',res.message)
				router.push("/plain")
			}
		
		return res
	},
	error => {

		return Promise.reject(error)
	}
)

export default service
